import React from 'react';
import './ConnectionIndicator.css';

function ConnectionIndicator({ isConnected }) {
    return (
        <div className={`connection-indicator ${isConnected ? 'connected' : 'disconnected'}`} />
    );
}

export default ConnectionIndicator; 